import { Component, ElementRef, inject, ViewChild, ViewContainerRef } from '@angular/core';
import { ServiceService } from '../../services/service/service.service';
import { CustomerService } from '../../services/customer/customer.service';
import { OrderService } from '../../services/order/order.service';
import { ServiceListFilter } from '../../lib/interfaces/ServiceListFilter';
import { OverlayService } from '../../services/overlay/overlay.service';
import { SuggestionFormComponent } from '../suggestion-form/suggestion-form.component';
import { take, timer } from 'rxjs';

@Component({
    selector: 'app-company-overview',
    templateUrl: './service-overview.component.html',
    styleUrls: ['./service-overview.component.scss'],
})
export class ServiceOverviewComponent {
    @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

    protected serviceUIDs: string[] = [];

    protected serviceService: ServiceService = inject(ServiceService);
    protected customerService: CustomerService = inject(CustomerService);
    protected orderService: OrderService = inject(OrderService);
    protected overlayService: OverlayService = inject(OverlayService);
    protected viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
    protected searchMenuOpen: boolean = false;
    protected addressSuggestions: string[] = [];
    protected selectedAddress: string = '';
    protected mockAddresses: string[] = [
        'Bischofshofen Salzburger Straße 18',
        'St. Johann im Pongau Street 1',
        'St. Johann im Pongau Street 15',
        'St. Johann im Pongau Street 42',
        'Werfen Street 44',
    ];

    constructor() {
        this.serviceService.fetchAllUIDs().subscribe((serviceUIDs: string[]): void => {
            this.serviceUIDs = serviceUIDs;
        });
        if (this.customerService.getToken()) {
            this.customerService.authenticate(undefined);
        }

        this.orderService.order.service = undefined;
    }

    protected updateFilter(servicesListFilter: ServiceListFilter): void {
        this.serviceService.fetchAllUIDsByFilter(servicesListFilter).subscribe((serviceUIDs: string[]): void => {
            this.serviceUIDs = serviceUIDs;
        });
    }

    protected openOverlayForm(): void {
        this.overlayService.open(this.viewContainerRef, SuggestionFormComponent, {
            title: 'Vorschlagen',
            iconType: 'restaurant',
            description: 'This is a description',
        });
    }

    protected closeSearchMenu(): void {
        timer(300)
            .pipe(take(1))
            .subscribe(() => {
                this.searchMenuOpen = false;
            });
    }

    protected onInput(inputValue: string): void {
        if (!inputValue.trim()) {
            return;
        }

        this.addressSuggestions = this.mockAddresses.filter((address) =>
            address.toLowerCase().includes(inputValue.toLowerCase()),
        );
    }

    protected onSearchSubmit(): void {
        if (!this.searchInput?.nativeElement?.value) {
            return;
        }

        this.selectedAddress = this.searchInput.nativeElement.value;
        this.closeSearchMenu();
    }

    protected setSearchInput(searchInput: string): void {
        if (!this.searchInput) return;

        this.searchInput.nativeElement.value = searchInput;
        this.onSearchSubmit();
        this.closeSearchMenu();
    }
}
